import lmsAPI from "../lmsAPI";

class locationBulkUpdateService {
  async create({ locationIDs, updateParams }) {
    const res = await lmsAPI.post(`/locations/bulk_update`, {
      location_ids: locationIDs,
      update_params: updateParams,
    });
    return res.data;
  }

  async delete({ locationIDs }) {
    const res = await lmsAPI.delete(`/locations/bulk_update`, {
      data: { location_ids: locationIDs },
    });
    return res.data;
  }
}

export default new locationBulkUpdateService();
